// frontend/src/contexts/ThemeContext.js
import React, { createContext, useState, useEffect, useMemo } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        const saved = localStorage.getItem('theme');
        if (saved === 'light' || saved === 'dark') return saved;
        try {
            return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        } catch (_) {
            return 'dark';
        }
    });

    useEffect(() => {
        // Aplica o tema ao document.documentElement (html) e body
        document.documentElement.setAttribute('data-theme', theme);
        document.body.setAttribute('data-theme', theme);
        
        // Também aplica ao root para garantir compatibilidade
        const root = document.getElementById('root');
        if (root) {
            root.setAttribute('data-theme', theme);
        }
        
        // Salva a escolha no localStorage
        localStorage.setItem('theme', theme);
        
        // Força a aplicação das variáveis CSS
        document.documentElement.style.setProperty('color-scheme', theme);
    }, [theme]);

    useEffect(() => {
        const saved = localStorage.getItem('theme');
        if (saved === 'light' || saved === 'dark') return;
        let mql = null;
        try {
            mql = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
        } catch (_) {
            mql = null;
        }
        if (!mql) return;

        const onChange = (e) => {
            setTheme(e.matches ? 'dark' : 'light');
        };
        try {
            if (mql.addEventListener) mql.addEventListener('change', onChange);
            else if (mql.addListener) mql.addListener(onChange);
        } catch (_) {}
        return () => {
            try {
                if (mql.removeEventListener) mql.removeEventListener('change', onChange);
                else if (mql.removeListener) mql.removeListener(onChange);
            } catch (_) {}
        };
    }, []);

    const toggleTheme = () => {
        setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
    };

    const value = useMemo(() => ({ theme, toggleTheme }), [theme]);

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};
